import { render, staticRenderFns } from "./CartWaiterOrders.vue?vue&type=template&id=a8a93c74"
import script from "./CartWaiterOrders.vue?vue&type=script&lang=js"
export * from "./CartWaiterOrders.vue?vue&type=script&lang=js"
import style0 from "./CartWaiterOrders.vue?vue&type=style&index=0&id=a8a93c74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports